export default {
    API_ENDPOINT: 'http://localhost:8000/api'
  }